module.exports = __webpack_public_path__ + "img/icon-search-white.88d59ee7.svg";